import { ApiError } from './types/error.types';
import type { SentryContext, SentryTag } from './types/sentry.types';

export type LogErrorFunction = (error: unknown, context?: SentryContext, tags?: SentryTag[]) => void;

interface SentryInstance {
    captureException: (error: unknown) => void;
    setContext: (name: string, value: Record<string, unknown> | null) => void;
    setTag: (name: string, value: string | number | bigint | boolean | symbol | null | undefined) => void;
}

export const createLogError = (sentry: SentryInstance): LogErrorFunction => {
    return (error, context, tags) => {
        // Use context from ApiError if available, otherwise use provided context
        const errorContext = error instanceof ApiError && error.context ? error.context : context;

        try {
            if (errorContext) {
                sentry.setContext(errorContext.name, errorContext.value);
            }
            if (tags && tags.length > 0) {
                for (const tag of tags) {
                    sentry.setTag(tag.name, tag.value);
                }
            }
            sentry.captureException(error);
        } catch (sentryError) {
            console.warn('Sentry logging failed', sentryError);
        } finally {
            // Sentry context/tags are persistent, clear after capture
            if (errorContext) {
                sentry.setContext(errorContext.name, null);
            }
            if (tags && tags.length > 0) {
                for (const tag of tags) {
                    sentry.setTag(tag.name, undefined);
                }
            }
        }
    };
};
